<template>
  <div class="map uk-align-center">
    <div id="map" class="map uk-flex-1"></div>

    <div id="marker" title="Marker"></div>

    <div class="contact-details-container">
      <div class="contact-details-wrapper">
        <div uk-grid>
            <div class="uk-width-1-2@s">
            <div>
              <div>
                <span class="icon-theme-color" uk-icon="world"></span>
                <a
                  href="https://www.google.com/maps/place/Bladvlinder+4,+3544+DD+Utrecht/@52.0913023,5.0520137,17z/data=!3m1!4b1!4m5!3m4!1s0x47c66ff2fc6183bb:0x50fdab9863d57c23!8m2!3d52.0913023!4d5.0542024"
                >
                  <span class="uk-text-middle">Bladvlinder 4, 3544DD Utrecht</span>
                </a>
              </div>
              <div>
                <span class="icon-theme-color" uk-icon="receiver"></span>
                <a href="tel:0302072007">
                  <span>030 207 2007</span>
                </a>
              </div>
              <div>
                <span class="icon-theme-color" uk-icon="mail"></span>
                <a href="mailto:info@DNZProjects.nl">
                  <span>info@DNZProjects.nl</span>
                </a>
              </div>
              <div>
              <a href="https://www.kvk.nl/zoeken/?source=all&q=67290795&start=0&site=kvk2014" target="_blank">
                <span class="icon-theme-color" uk-icon="icon:code"></span>
                <span>KvK 67290795</span>
                </a>
              </div>
            </div>
          </div>
          <div class="uk-width-1-2@s">
            <div>
              <div>
                <a href="https://www.facebook.com/DNZ-Projects-314882462639303" target="_blank">
                  <span class="footer-label">Volg ons op:</span>
                  <span class="icon-theme-color" uk-icon="icon:facebook"></span>
                </a>
              </div>
              <span
                style="cursor: pointer;"
                uk-toggle="target: #message-modal"
              >Naar contactformulier:</span>
              <span class="icon-theme-color" uk-icon="icon:arrow-right"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css';
import { Map, View } from 'ol';
import Overlay from 'ol/Overlay';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat } from 'ol/proj';
// import axios from "axios";

export default {
  mounted() {
    // const markerPos = fromLonLat([5.068327, 52.101776], 'EPSG:3857');
    // const mapCenterPos = fromLonLat([5.068327, 52.090776], 'EPSG:3857');
    const markerPos = fromLonLat([5.068327, 52.1013781], 'EPSG:3857');
    const mapCenterPos = fromLonLat([5.068327, 52.0903781], 'EPSG:3857');

    this.map = new Map({
      target: 'map',
      controls: [],
      view: new View({
        enableRotation: false,
        center: [0, 0],
        zoom: 14,
      }),
      layers: [
        new TileLayer({
          source: new OSM({
            url: 'https://{a-c}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          }),
        }),
      ],
    });

    this.map.getView().setCenter(mapCenterPos);

    this.map.addOverlay(
      new Overlay({
        position: markerPos,
        element: document.getElementById('marker'),
      }),
    );
  },
};
</script>

<style lang="less">
@import "../assets/vars.less";

.map {
  // position: absolute;
  // top: 0;
  // left: 0;
  height: calc(100vh - 15rem) !important ;
  max-width: 100rem;
  margin-top: -5rem;
  position: relative;

    @media screen and (max-width: 900px) {
  height: calc(100vh - 13rem) !important ;
      }
}

#marker {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: rgb(45, 147, 194);
  opacity: 0.5;
  margin-top: -15px;
  margin-left: -15px;
}

.contact-details-container {
  position: absolute;
  width: 100%;

  color: white;
  bottom: 0rem;
  // left: 3rem;
  // right: 3rem;

  span {
    color: white;
    margin-right: 1rem;
    margin-bottom: 0.3rem;
    text-decoration: none;
  }

  .icon-theme-color {
    color: @primary-color;
  }

  .label {
    margin-top: 0.5rem;
  }

  @media screen and (min-width: 901px) {
    // width: calc(100vw - 6rem) !important ;
    // bottom: 3rem;
    // left: 3rem;
    // padding: 4rem;
    .contact-details-wrapper {
      background: rgba(0, 0, 0, 0.65);
      margin: 3rem;
      padding: 4rem;
    }
  }

  @media screen and (max-width: 900px) {
    // width: calc(100vw - 3rem) !important ;
    // bottom: 1.5rem;
    // left: 1.5rem;
    // padding: 4rem;
    .map {
      margin-top: -4rem;
    }
    .contact-details-wrapper {
      background: rgba(0, 0, 0, 0.65);
      margin: 1rem;
      padding: 1rem;
    }
  }
}
</style>
